'use es6';

import { promotionKeys } from 'self-service-api/constants/Promotions';
import { getAllEligiblePromotions, getIsHsfxEligible, getProductPromotion, getPromotionForSkuId, getIsEligibleForRetailPromotion, getIsEligibleForLatamPromotion, getIsEligibleForSummer2022RetailPromotion } from 'pricing-pages-lib/utils/promotionUtils';
import { makeRequestStatusSelector } from 'pricing-pages-unified-ui/selectors/RequestStatusSelectors';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { FetchPromotionsRequestTypes } from '../actions/PromotionActions';
import { transformState } from './SelectorUtils';
export const fetchPromotionsStatus = makeRequestStatusSelector(FetchPromotionsRequestTypes.REQUEST);
export const productPromotionSelector = createSelectorFromUtil(getProductPromotion, transformState);
export const promotionForSkuIdSelector = createSelectorFromUtil(getPromotionForSkuId, transformState); // returns an array of all promotions keys with a discount that can be applied

export const allEligibleDiscountsSelector = createSelectorFromUtil(getAllEligiblePromotions, transformState);
export const isHSFXEligibleSelector = createSelectorFromUtil(getIsHsfxEligible, transformState);
export const isHsfsSeedEligibleSelector = state => {
  const allPromotions = allEligibleDiscountsSelector(state);
  return allPromotions.includes(promotionKeys.HSFS_SEED);
};
export const getHsfsApplicationStatus = state => {
  return state.hsfs.status;
};
export const isLatamEsEligibleSelector = state => {
  const allPromotions = allEligibleDiscountsSelector(state);
  return allPromotions.includes(promotionKeys.LATAM_AND_BRAZIL_ES_PRO);
};
export const isEligibleForRetailPromotionSelector = createSelectorFromUtil(getIsEligibleForRetailPromotion, transformState);
export const isEligibleForSummer2022RetailPromotionSelector = createSelectorFromUtil(getIsEligibleForSummer2022RetailPromotion, transformState);
export const isEligibleForLatamPromotionSelector = createSelectorFromUtil(getIsEligibleForLatamPromotion, transformState);